import styled from 'styled-components';
export const ContactsNameWrapper = styled.div.withConfig({
  displayName: "contacts__ContactsNameWrapper"
})(["font-weight:600;& *:hover{text-decoration:none;}"]);
export const ContactsAvatarWrapper = styled.div.withConfig({
  displayName: "contacts__ContactsAvatarWrapper"
})(["width:40px;height:40px;"]);
export const ContactsListWrapper = styled.div.withConfig({
  displayName: "contacts__ContactsListWrapper"
})(["height:auto;overflow:auto;"]);